import { ProductsId } from 'app/models/types'
import { UserType } from 'app/models/types/common/UserType'

export const extendedProductRules: {
  [key: string]: {
    [key in UserType]?: {
      [key in ProductsId]?: {
        maxAmount: number
      } 
    }
  }
} = {
  'TR-TR': {
    customer: {
      adult: {
        maxAmount: 10
      }
    },
    'logged-in-customer': {
      adult: {
        maxAmount: 10
      }
    },
  }
}